import { icons } from '@ublend-npm/aulaui-next';
import React from 'react';
import { ReactEditor } from 'slate-react';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { AulaPlugin } from '../plugins';
import { audioType } from './audioType';

export const audio: AulaPlugin = (editableProps, editor, context) => {
  const { isVoid } = editor;
  editor.isVoid = (el) => el?.type === audioType || isVoid(el);

  return {
    ...editableProps,
    blockMenu: {
      ...editableProps.blockMenu,
      'Voice recording': ({ text, element, attributes, onClose }) => (
        <NestedMenuItem
          leftIcon={<icons.Mic />}
          key={text}
          text={text}
          attributes={{
            ...attributes,
            onClick: () => {
              const path = ReactEditor.findPath(editor, element);
              context?.setRecordingPath(path);
              onClose?.();
            },
          }}
        />
      ),
    },
  };
};
